"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const location_search_box_1 = __importDefault(require("../location-search-box"));
const LocationAnalyticsSearchBoxWrapper = ({ customLocations, customLocationIcon, gaProductName }) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
    }
    const sendGAEvent = (selectedLoc) => {
        if (typeof window !== 'undefined' && selectedLoc) {
            window.dataLayer.push({
                'event': `product_search`,
                'product_name': gaProductName,
                'product_search_term': selectedLoc.name.toLowerCase()
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(location_search_box_1.default, { customLocations: customLocations, customLocationIcon: customLocationIcon, sendAnalytics: sendGAEvent }));
};
exports.default = LocationAnalyticsSearchBoxWrapper;
